/* eslint-disable no-unused-vars */
import { makeStyles } from "@mui/styles";
import styles from "../../assets/jss/material-dashboard-react/views/dashboardStyle.js";
import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { useTranslation } from "react-i18next";
import API from "../../utils/API";

const useStyles = makeStyles(styles);

export default function SalesTreand() {
  const { t } = useTranslation();
  const translate = t;
  const classes = useStyles();
  const [options, setOptions] = useState({});
  const [series, setSeries] = useState([
    {
      name: "No Invoices",
      data: [],
    },
  ]);

  useEffect(() => {
    loadDataFromServer();
  }, []);

  async function loadDataFromServer() {
    try {
      const { data } = await API.post("/report/analytics", {
        template: "reports/analytics/dashboard/10_days_sale",
      });
      let config = {
        chart: {
          height: 150,
          type: "line",
          zoom: {
            enabled: false,
          },
        },
        title: {
          text: translate("Last 10 Days Invoices"),
          align: "left",
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "straight",
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"],
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: data.sale30daysConfig,
        },
      };
      console.log(config);
      setOptions(config);
      setSeries(data.sale30daysData);
    } catch (e) {
      console.error(e);
    }
  }

  return (
    <div id="chart">
      <ReactApexChart
        options={options}
        series={series}
        type="line"
        height={180}
      />
    </div>
  );
}
